<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 600 80"
    preserveAspectRatio="xMinYMid meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Gradient Definition -->
    <defs>
      <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="#CE2906" />
        <stop offset="33%" stop-color="#E04A20" />
        <stop offset="66%" stop-color="#E65820" />
        <stop offset="100%" stop-color="#FF7B00" />
      </linearGradient>
    </defs>

    <!-- Main Text -->
    <text
      x="0"
      y="50"
      font-size="50"
      font-family="Inter, Arial, sans-serif"
      font-weight="560"
      letter-spacing="0"
      fill="url(#textGradient)"
      textLength="540"
      lengthAdjust="spacingAndGlyphs"
    >
      WE ARE DRAFTEX
    </text>

    <!-- Subtitle -->
    <text
      x="0"
      y="75"
      font-size="18"
      font-family="Inter, Arial, sans-serif"
      font-weight="380"
      fill="#8c8c8c"
      textLength="250"
      lengthAdjust="spacingAndGlyphs"
    >
      DESIGN SERVICES
    </text>
  </svg>
</template>